import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { PoModule } from '@po-ui/ng-components';
import { ApiService } from '../../shared/service/api.service';
import { catchError, of } from 'rxjs';
import { ToasterService } from '../../shared/service/toaster.service';
import { ScannerComponent } from '../../shared/components/scanner/scanner.component';
import { Router } from '@angular/router';
import { ToasterComponent } from '../../shared/components/toaster/toaster.component';
import { PackService } from '../../shared/service/pack.service';

@Component({
  selector: 'app-pack',
  imports: [PoModule, CommonModule, ScannerComponent, ToasterComponent],
  templateUrl: './pack.component.html',
  styleUrls: ['./pack.component.css']
})
export class PackComponent implements OnInit, AfterViewInit {
  @ViewChild(ToasterComponent) toasterComponent!: ToasterComponent;
  
  packNumber: number = 0;
  packBarCode: string = '';
  packItens: any = [];

  constructor(
    private api: ApiService,
    private packService: PackService,
    private toasterService: ToasterService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.packItens = this.packService.getCapaPack(0, this.packBarCode);
  }

  ngAfterViewInit() {
    this.toasterComponent.alertClosed.subscribe(() => {
      this.focusInputBarcode();
    });
  }

  updatePackInfo(barcode: string) {
    if (barcode) {
      this.packBarCode = barcode;
      this.getPackInfo();
      this.focusInputBarcode();
    }
  }

  getPackInfo() {
    this.recoverPack().pipe(
      catchError((error) => {
        let errorMessage = '';
        if (error.error && Array.isArray(error.error) && error.error.length > 0) {
          errorMessage = error.error[0].message || 'Erro desconhecido.';
        } else if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = 'Ocorreu uma falha ao buscar o pack.';
        }
        this.toasterService.triggerAlert(errorMessage, 'warning');
        return of(false);
      })
    ).subscribe((data: any) => {
      if (data) {
        this.packNumber = data.packNumber;
        this.openDetail(this.packNumber);
      }
    })
  }

  recoverPack() {
    return this.packService.getCapaPackGroup(0, this.packBarCode);
  }

  openDetail(packNumber: number) {
    this.router.navigate(['/detail-pack'], {
      queryParams: {
        packnumber: packNumber,
      }
    });
  }

  private focusInputBarcode() {
    setTimeout(() => {
      const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 100);
  }
}
